import {
  Accordion,
  Button,
  Text,
  Title,
  Table,
  Select,
  Group,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useServerApi } from "../../hooks/useServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";

const ReportUser = ({ description }) => {
  const [loading, setLoading] = useState(false);

  const [api] = useServerApi();
  const { t } = useTranslation();
  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.User.getReport();
      setLoading(false);

      if (result && result.data && result.data.url) {
        window.open(result.data.url, "_blank");
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">{description}</Text>
      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
      >
        {t("Download")}
      </Button>
      <></>
    </div>
  );
};

export default ReportUser;
